import { sample, type EventCallable, type Store } from 'effector'

export function postpone<T>({
  clock,
  until,
  target,
}: {
  clock: EventCallable<T>
  until: Store<boolean>
  target: EventCallable<T>
}): EventCallable<T> {
  return sample({
    clock: [clock, until],
    source: clock,
    filter: until,
    target,
  })
}
